"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
function setInlineStyle(element, style) {
    try {
        for (var prop in style) {
            try {
                var value = typeof style[prop] === "string"
                    ? style[prop].replace("!important", "")
                    : style[prop];
                var important = value === style[prop] ? "" : "important";
                if (prop in element.style && !important)
                    element.style[prop] = value;
                else
                    element.style.setProperty(prop, value, important);
            }
            catch (e) {
                console.error(e);
            }
        }
    }
    catch (e) {
        throw e;
    }
}
function setAttribute(element, name, value) {
    try {
        if (name === "style")
            setInlineStyle(element, value);
        else if (name in element)
            element[name] = value;
        else
            element.setAttribute(name, value);
    }
    catch (e) {
        throw e;
    }
}
function elemArgs(args) {
    var _a = typeof args[0] === "string" ? [args[0], ""] : [args[0].tag, args[0].id], tag = _a[0], id = _a[1];
    var attributes = {};
    var children = [];
    if (args[1]) {
        if (typeof args[1] === "string")
            children = [args[1]];
        else if (Array.isArray(args[1]))
            children = args[1];
        else
            attributes = args[1];
    }
    if (args[2]) {
        if (typeof args[2] === "string")
            children = [args[2]];
        else
            children = args[2];
    }
    if (id)
        attributes = __assign(__assign({}, attributes), { id: id });
    return [tag, attributes, children];
}
function elem() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    try {
        var _a = elemArgs(args), tag = _a[0], attributes = _a[1], children = _a[2];
        var el = document.createElement(tag);
        for (var attr in attributes)
            setAttribute(el, attr, attributes[attr]);
        for (var _b = 0, children_1 = children; _b < children_1.length; _b++) {
            var child = children_1[_b];
            el.appendChild(typeof child === "string" ? document.createTextNode(child) : child);
        }
        return el;
    }
    catch (e) {
        console.error(e);
        return "";
    }
}
function initRule(sheet, selector, content) {
    var index = sheet.cssRules.length;
    sheet.insertRule(selector + (content ? " { content: \"".concat(content, "\"; }") : " {}"), index);
    var rule = sheet.cssRules.item(index);
    return rule;
}
var styleElement;
function style(selector, properties) {
    if (!styleElement) {
        styleElement = document.createElement("style");
        document.head.appendChild(styleElement);
    }
    if (!styleElement.sheet)
        throw new Error("Unable to add style rule.");
    try {
        var rule = initRule(styleElement.sheet, selector, properties.content);
        setInlineStyle(rule, properties);
        return rule;
    }
    catch (e) {
        console.error(e);
        return null;
    }
}
function assertElement(el, tag) {
    if (!el)
        throw new ReferenceError("Element not found.");
    if (tag && el.tagName.toLowerCase() !== tag)
        throw new TypeError("tag parameter and element's tag do not match.");
    return el;
}
function queryElem(selector, tag) {
    var el = document.querySelector(selector);
    return assertElement(el, tag);
}
function getElem(id, tag) {
    var el = document.getElementById(id);
    return assertElement(el, tag);
}
function getChild(id, tag) {
    var _a;
    var el = (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.firstElementChild;
    return assertElement(el, tag);
}
function getParent(id, tag) {
    var _a;
    var el = (_a = document.getElementById(id)) === null || _a === void 0 ? void 0 : _a.parentElement;
    return assertElement(el, tag);
}
var count = 0;
function refElem(tag) {
    var id = "e" + (count++).toString(36);
    var ref = function () {
        return getElem(id, tag);
    };
    ref.id = id;
    ref.tag = tag;
    ref.selector = "#" + id;
    ref.toString = function () { return ref.selector; };
    return ref;
}
var thisModule = Object.freeze({
    elem: elem,
    style: style,
    getElem: getElem,
    queryElem: queryElem,
    getChild: getChild,
    getParent: getParent,
    refElem: refElem,
});
Object.defineProperty((typeof self !== "undefined" && self) || globalThis, "iuai", {
    value: thisModule,
    enumerable: true,
});
